export const authStateKey = 'auth';
export const authCodeSentAtSelectorKey = 'codeSentAt';
export const authCheckAuthSelectorKey = 'checkAuth';
